import React from 'react';
import Footer from '../Footer/Footer';
import ScrollAnimation from 'react-animate-on-scroll';
import {withRouter} from 'react-router-dom';

const Content = ( props ) => {
    var zaw_styl;
    if (props.pTop!="72") {
        zaw_styl = {top: '95%',
        position: 'absolute',
        width: '100%',
        margin: '0 auto',
        zIndex: '10',
        background: '#F5F3EF',
        padding: '5em 0 0 0',
        boxShadow: '0px -2px 3px 0px rgba(0,0,0,0.3)'}
    } else {
        zaw_styl = {top: '95%',
        position: 'absolute',
        width: '100%',
        margin: '0 auto',
        zIndex: '10',
        background: '#F5F3EF',
        padding: '5em 0 0 0',
        boxShadow: '0px -2px 3px 0px rgba(0,0,0,0.3)'}
    };
    var kontener = {
        position: 'relative',
        width: '1200px',
        margin: '0 auto'
    };
    if (window.innerHeight > window.innerWidth || window.innerWidth < 1200)
    {
        zaw_styl.width= (window.innerWidth) + 'px',
        kontener.width= '100vw'
    };
    return (
        <div style={zaw_styl} className="index10">
             <div style={kontener}>{props.children}</div>
                <Footer />
        </div>
    )
}

export default Content;


// WEBPACK FOOTER //
// ./src/Content/Content.js